// extracted by mini-css-extract-plugin
module.exports = {"form":"TodoForm_form__ZO9SE","form-group":"TodoForm_form-group__eaaAn","form-btn":"TodoForm_form-btn__3JNm0"};